class LayerSettings {
  constructor(layer_data) {
    this.layer_data = layer_data;
    this.id = `layer-${layer_data?.uuid}`;
    this.layer = this.createLayer();
    this.visible = true;
    this.layer_group_id = "";
    this.name = { en: "", es: "" };
    this.legend = null;
    this.filters = [];
    this.opacity = 1;
    this.zIndex = 40;
    this.onClickGetInfo = null;
    this.controlSettingsComponent = false;
    this.description = { en: "", es: "" };
    this.attribution_html = { en: "", es: "" };
    this.style = {};
    this.styles = [];

    //Se visualiza la capa en el menú? por defecto sí, pero la capa de feature seleccionada no
    this.display = true;
  }

  getFeatureInfoOnClick = () => {};

  createLayer = () => {};
}
export default LayerSettings;
